import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-insights',
  templateUrl: './insights.component.html',
  styleUrls: ['./insights.component.scss']
})
export class InsightsComponent implements OnInit {
    filterValueNavBar: string = null;
    public data: Object[];
    public chartHeading: string;
    public chartLabel: Object;
    public legend: Object;
    public toolTipSettings: Object;
    public palette: string[];

  constructor(    ) { 
    this.chartHeading = "Heading?",
    this.data = [
        { type: "A", count: "50" },
        { type: "B", count: "20" }
    ],
    this.chartLabel = {
        visible: true,
        position: "Inside",
        name: "type",
    },
    this.legend = {
        visible: true,
        position: "Bottom",
        height: "8%",
        width: "33%"
    },   
    this.toolTipSettings = {
        enable: true,
        format: "${point.x} : <b>${point.y}%</b>"
    },
    this.palette = ["#7d7d7d", "#adff2f"]
  }

  navBarForms = []
  allSearchForms: any

  ngOnInit(): void {
  }

  applyFilterSideNav(event: Event) {
    this.filterValueNavBar = (event.target as HTMLInputElement).value;
    //let count = 0
    //console.log(this.filterValueNavBar)
    if (this.filterValueNavBar.length > 0) {
      this.navBarForms = []
      this.search()
    }
    else {
      this.navBarForms = this.allSearchForms
    }
  }

  search() {
    this.allSearchForms.filter(form => {
      if ((form.name.trim().toLowerCase().indexOf(this.filterValueNavBar.trim().toLowerCase()) > -1)) {
        this.navBarForms.push(form)
      }
    })
  }


}
